<div class="row page-header">
    <div class="col-12">
        <h1>Validation <small>View reports on validation issues within the data</small></h1>
    </div>
</div>

<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1" [destroyOnHide]="false">
        <a ngbNavLink>GPS Records </a>
        <ng-template ngbNavContent>
            <p>Showing the most recent 500,000 GPS Records according to Date Created.</p>
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid1"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid1.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid1.initialize(mainGrid)"
                        (destroy)="grid1.destroy()"
                        [itemsSource]="grid1.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Equip'" [binding]="'e'" [width]="80"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Description'" [binding]="'d'" [minWidth]="200" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'j'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Vista Job'" [binding]="'vj'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Reading Date'"
                            [binding]="'r'"
                            [format]="'MM/dd/yyyy hh:mm tt'"
                            [width]="180"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Date Created'"
                            [binding]="'dc'"
                            [format]="'MM/dd/yyyy hh:mm tt'"
                            [width]="180"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Hour Meter'" [binding]="'h'" [width]="90"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Odometer'" [binding]="'o'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Key Id'" [binding]="'k'" [width]="110" [format]="'d'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'GPS Poll'" [binding]="'g'" [width]="110" [format]="'d'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Coordinates'" [binding]="'c'" [minWidth]="200" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Notes'" [binding]="'n'" [minWidth]="200" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>

<div [hidden]="isInitialLoading"></div>
